import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const useResponsiveImageWidth = () => {
  const theme = useTheme()

  const isXl = useMediaQuery(theme.breakpoints.up('xl'))
  const isLg = useMediaQuery(theme.breakpoints.up('lg'))
  const isMd = useMediaQuery(theme.breakpoints.up('md'))
  const isSm = useMediaQuery(theme.breakpoints.up('sm'))
  const isS = useMediaQuery(theme.breakpoints.up('s'))

  const customBreakpointImageWidth = {
    xs: '300',
    s: '600',
    sm: '900',
    md: '1200',
    lg: '1600',
    xl: '1920'
  }

  if (isXl) {
    return customBreakpointImageWidth.xl
  } else if (isLg) {
    return customBreakpointImageWidth.lg
  } else if (isMd) {
    return customBreakpointImageWidth.md
  } else if (isSm) {
    return customBreakpointImageWidth.sm
  } else if (isS) {
    return customBreakpointImageWidth.s
  } else {
    return customBreakpointImageWidth.xs
  }
}

export default useResponsiveImageWidth
